$(document).ready(function () {
  // Close button logic
  if ($(".announcement-bar__close-button").length > 0) {
    let close_btns = $(".announcement-bar__close-button");

    close_btns.each((index, close_btn) => {
      let parent_section = $(close_btn).closest(".section-announcement");

      $(close_btn).on("click", () => {
        parent_section.hide();
        document.body.classList.add("announcement-hide");
      });
    });
  }

  // Carousel logic
  const sliderElements = document.querySelectorAll("[data-announcement-slider]");

  sliderElements.forEach((sliderEl) => {
    const bar = sliderEl.closest(".announcement-bar");
    if (!bar) return;

    const autoplayEnabled = bar.dataset.autoplay === "true";
    const speed = parseInt(bar.dataset.autoplaySpeed, 10) || 5;

    const swiperConfig = {
      loop: true,
      slidesPerView: 1,
      allowTouchMove: true,
      speed: 500,
      navigation: {
        nextEl: bar.querySelector(".announcement-bar__arrow--next"),
        prevEl: bar.querySelector(".announcement-bar__arrow--prev"),
      },
    };

    if (autoplayEnabled) {
      swiperConfig.autoplay = {
        delay: speed * 1000,
        disableOnInteraction: false,
      };
    }

    new Swiper(sliderEl, swiperConfig);
  });
});
